import { AppContext, h, reactive, render } from "vue";

import { SnackbarMessage } from "./interfaces";

class SnackbarService {
  private messages: Array<SnackbarMessage & { id: string }>;
  private messageId = 0;

  constructor(appContext?: AppContext) {
    this.messages = reactive([]);

    this.add = this.add.bind(this);
    this.clear = this.clear.bind(this);
    this.remove = this.remove.bind(this);
    this.update = this.update.bind(this);

    import("./Snackbar.vue").then((m) => {
      if (m.default) {
        const a = h(m.default, {
          // ENG-21695 Snackbar.vue declares message ids as `number`, but the service assigns
          // string ids at runtime — cast to the component's prop contract (cross-file id mismatch).
          messages: this.messages as unknown as Array<SnackbarMessage & { id: number }>,
          onRemove: (item: SnackbarMessage & { id: number }) => {
            this.messages.splice(
              this.messages.indexOf(item as unknown as SnackbarMessage & { id: string }),
              1,
            );
          },
        });
        if (appContext) {
          a.appContext = appContext;
        }
        try {
          render(a, document.body);
        } catch {
          // ignore
        }
      }
    });
  }

  add(m: SnackbarMessage & { id?: string }) {
    // ENG-21695 first id is numeric 0 via the pre-existing && short-circuit; cast preserves runtime
    m.id = (m.id || (this.messageId++ && this.messageId.toString())) as string;

    // @ts-expect-error not the correct type
    this.messages.push(m);

    return () => {
      // @ts-expect-error not the correct type
      this.messages.splice(this.messages.indexOf(m), 1);
    };
  }

  clear() {
    this.messages.length = 0;
  }

  remove(id: string) {
    const index = this.messages.findIndex((message) => message.id === id);

    if (index === -1) return false;

    this.messages.splice(index, 1);
  }

  update(id: string, message: string) {
    const notification = this.messages.find((message) => message.id === id);

    if (!notification) return false;

    notification.message = message;
  }
}

let service: SnackbarService | undefined = undefined;
export function useSnackbar(appContext?: AppContext) {
  return service ?? (service = new SnackbarService(appContext));
}
